<template>
  <pdf :content="src"></pdf>
</template>

<script>
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

export default {
  components: {
    pdf
  },
  data() {
    return {
      src: '',
      numPages: 0,
      page: 1,
      currentPage: 0
    }
  },

  methods: {
    OpenPdf() {
      let url = `/disposition/get/pdf/${this.$route.params.day}`
      this.$http.get(url, {responseType: 'blob'})
          .then(resp => {
            window.open(URL.createObjectURL(resp.data));

          })
          .catch(err => {
            console.error(err)
          })

    },
  },
  mounted() {
    this.OpenPdf();

  }
}
</script>